import axios from 'axios';

/**
 * Captura errores HTTP (Axios), errores de Vue y rechazos de promesas no capturados.
 * Usa la instancia por defecto `axios` (mismo módulo que el resto de la app).
 */
export function installErrorNotebook(app, store, router) {
  if (typeof window !== 'undefined') {
    window.addEventListener(
      'error',
      (ev) => {
        try {
          const route = router.currentRoute?.value;
          store.dispatch('errorNotebook/pushWindowError', { ev, route });
        } catch {
          /* noop */
        }
      },
      true
    );
  }

  router.onError((err) => {
    try {
      const route = router.currentRoute?.value;
      store.dispatch('errorNotebook/pushRouterError', { err, route });
    } catch {
      /* noop */
    }
  });

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      try {
        const route = router.currentRoute?.value;
        store.dispatch('errorNotebook/pushAxiosError', { error, route });
      } catch {
        /* noop */
      }
      return Promise.reject(error);
    }
  );

  const prev = app.config.errorHandler;
  app.config.errorHandler = (err, instance, info) => {
    try {
      const route = router.currentRoute?.value;
      store.dispatch('errorNotebook/pushVueError', { err, info, route });
    } catch {
      /* noop */
    }
    if (typeof prev === 'function') {
      prev(err, instance, info);
    } else {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  if (typeof window !== 'undefined') {
    window.__kosexaTiendaPushError = (message, detail) => {
      try {
        const route = router.currentRoute?.value;
        store.dispatch('errorNotebook/pushManual', {
          summary: message == null ? '' : String(message),
          detail: detail == null ? '' : String(detail),
          route,
        });
      } catch {
        /* noop */
      }
    };
    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason;
      if (axios.isCancel?.(reason)) return;
      if (reason && reason.isAxiosError) return;
      try {
        const route = router.currentRoute?.value;
        store.dispatch('errorNotebook/pushRejection', { reason, route });
      } catch {
        /* noop */
      }
    });
  }
}
